import { render, staticRenderFns } from "./MubadalaForCustomerEFormThankYou.vue?vue&type=template&id=c14fd720&scoped=true&"
import script from "./MubadalaForCustomerEFormThankYou.vue?vue&type=script&lang=js&"
export * from "./MubadalaForCustomerEFormThankYou.vue?vue&type=script&lang=js&"
import style0 from "./MubadalaForCustomerEFormThankYou.vue?vue&type=style&index=0&id=c14fd720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14fd720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
